export class CircularIterator<T> {
  private index = 0;

  constructor(private array: T[]) {
    if (array.length === 0) {
      throw new Error('Array cannot be empty');
    }
  }

  next(): T {
    const value = this.array[this.index];
    this.index = (this.index + 1) % this.array.length;
    return value;
  }

  previous(): T {
    this.index = (this.index - 1 + this.array.length) % this.array.length;
    return this.array[this.index];
  }

  current(): T {
    return this.array[this.index];
  }

  reset(): void {
    this.index = 0;
  }

  peek(offset: number = 1): T {
    const peekIndex = (this.index + offset) % this.array.length;
    return this.array[peekIndex];
  }
}
